import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import classnames from 'classnames';
import {Request, PUT, DELETE} from 'requests';
import {default as RequestsMixin, HAS_FAILED, HAS_ERRORS, IS_DONE, IS_NOT_ALLOWED} from 'requests/RequestsMixin';
import * as actions from '../actions';
import ImageFormMixin from '../mixins/ImageFormMixin';
import DirectToCloudDropzone from './DirectToCloudDropzone';
import RemoveImageModal from './RemoveImageModal';

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const EditImageForm = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    workingSetImage: ImmutablePropTypes.record.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onDeleteWorkingSetImage: PropTypes.func.isRequired,
  },

  mixins: [ImageFormMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      updating: false,
      showConfirmDeleteImage: false,
    };
  },

  transitions(register) {
    register({
      request: this.requests.updateImage,
      to: IS_DONE,
      call(rm) {
        this.props.onSuccess();
      },
    });

    register({
      request: this.requests.updateImage,
      to: HAS_ERRORS,
      call(rm) {
        this.setState({updating: false});
      },
    });

    register({
      request: this.requests.uploadImage,
      to: HAS_FAILED,
      call(rm) {
        this.setState({
          uploading: false,
          uploadFailed: true,
        });
      },
    });
  },

  updateRecord() {
    let record = this.props.workingSetImage
      .set('name', this.state.name);

    if (this.state.imageUrl) {
      record = record.set('uploadedUrl', this.state.imageUrl)
    }

    return record;
  },

  handleEditClicked() {
    const record = this.updateRecord();
    const request = new Request({
      url: ['api', 'kits', this.props.kitToken, 'working-set-images', record.id],
      method: PUT,
      record,
    });

    this.setState({
      updating: true,
    });

    this.setRequest({
      updateImage: request,
    }, {skipDispatch: true});

    this.props.dispatch(
      actions.updateImageFromDropzone(request, record, this.state.dropzone)
    );
  },

  handleDeleteImageClicked(event) {
    event.preventDefault();

    this.setState({showConfirmDeleteImage: true});
  },

  handleDeleteImageConfirmed() {
    this.setState({
      showConfirmDeleteImage: false,
    }, () => {
      this.props.onDeleteWorkingSetImage(this.props.workingSetImage);
    });
  },

  handleDeleteImageCanceled() {
    this.setState({
      showConfirmDeleteImage: false,
    });
  },

  render() {
    const {kitToken, workingSetImage} = this.props;
    const nameHasNotChanged = workingSetImage.name === this.state.name;
    const editDisabled = this.state.updating || this.state.nameIsInvalid || (nameHasNotChanged && !this.state.imageUrl)
    const uploadFailedElement = (this.state.uploadFailed) ?
      (
        <div id="build-error" className="alert alert-danger bg-body has-icon" role="alert">
          <i className="ficon ficon-warning alert-icon text-lg"></i>
          <p className="m-xs-b-0"><strong>Oops!</strong> There was an issue uploading your image. Try again.</p>
        </div>
      ) : null;

    return (
      <div>
        <RemoveImageModal
          show={this.state.showConfirmDeleteImage}
          workingSetImage={workingSetImage}
          onRemovedImage={this.handleDeleteImageConfirmed}
          onClosed={this.handleDeleteImageCanceled}
        />

        {uploadFailedElement}

        <form className="simple-form form-horizontal" action="" method="">
          <div className="form-group row">
            <label className="string col-xs-3 form-control-label p-xs-r-sm">Replace Original</label>

            <div className="col-xs-9">
              <DirectToCloudDropzone {...this.directToCloudDropzoneProps()} />
            </div>
          </div>

          {this.nameFormGroup(this.requests.updateImage)}

          <div className="form-group row">
            <div className="col-xs-9 col-xs-offset-3">
              <button onClick={this.handleEditClicked} disabled={editDisabled} className="btn btn-primary btn-block btn-lg">
                <span>
                  Edit Image <i className="ficon ficon-check-circle p-xs-l-xs"></i>
                </span>
              </button>
              <div className="hr m-xs-t-md">
                <span className="hr-text bg-white">or</span>
              </div>
            </div>
          </div>
        </form>

        <div className="row m-xs-b-lg">
          <div className="col-xs-3 col-xs-offset-3 p-xs-r-sm">
            <Link to={`/kits/${kitToken}/images`} className="btn btn-secondary btn-block btn-lg">Cancel</Link>
          </div>

          <div className="col-xs-6 p-xs-l-0">
            <a onClick={this.handleDeleteImageClicked} href="#" className="btn btn-secondary btn-block btn-lg">
              Delete Image
              <i className="ficon ficon-trash p-xs-l-xs"></i>
            </a>
          </div>
        </div>
      </div>
    );
  },
});

export default connect(mapStateToProps)(EditImageForm);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/EditImageForm.js